'use client';

import React from 'react';

import Link from 'next/link';

import R2Image from '@/components/ui/R2Image';
import { getExternalLinkProps } from '@/constants/routes';

interface MediaLogoItem {
  name: string;
  logo: string;
  url?: string | null;
}

interface MediaLogoGridProps {
  items: MediaLogoItem[];
}

const MediaLogoGrid: React.FC<MediaLogoGridProps> = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="grid grid-cols-4 items-center gap-3 pt-4 sm:gap-6">
      {items.map((media, index) => {
        const MediaContent = (
          <div className="flex h-12 items-center justify-center sm:h-16">
            <R2Image
              path={media.logo}
              alt={media.name}
              width={120}
              height={48}
              className="max-h-full max-w-[80%] cursor-pointer object-contain filter transition-all duration-300 hover:grayscale-80"
            />
          </div>
        );

        return media.url ? (
          <Link
            key={`${media.name}-${index}`}
            href={media.url}
            {...getExternalLinkProps()}
            className="block transition-opacity hover:opacity-80"
            aria-label={`Read ${media.name} article`}
          >
            {MediaContent}
          </Link>
        ) : (
          <div key={`${media.name}-${index}`}>{MediaContent}</div>
        );
      })}
    </div>
  );
};

export default MediaLogoGrid;
